// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--QtjDs","container--active":"a10a3f92e9--container--active--foeaz","play-button":"a10a3f92e9--play-button--LiWuf"};